import * as React from 'react';

function SvgPlaceholderimage(props) {
  return (
    <svg viewBox="0 0 182 112" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path fill="#E8E8E8" d="M0 0h182v112H0z" />
      <ellipse cx={73.707} cy={37.197} rx={7.169} ry={7.198} fill="#F5F5F5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.277 39.65a2 2 0 00-3.314 0L82.682 72.614 66.267 56.498a2 2 0 00-3.026.26L45.517 81.416A1 1 0 0046.33 83H135.694a1 1 0 00.829-1.56l-28.246-41.79z"
        fill="#F5F5F5"
      />
    </svg>
  );
}

export default SvgPlaceholderimage;
